import { imageIsBusy } from './ImageStore';

export const updateImageIsBusy = (value) => imageIsBusy.update((oldValue) => value);
